var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleUpSolid = function SvgCircleUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.438 0-8 3.594-8 8 0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8Zm3.938 7.969a.964.964 0 0 1-1.407 0L13 10.438V16c0 .563-.469 1-1 1-.563 0-1-.438-1-1v-5.563L9.437 11.97a.964.964 0 0 1-1.406 0 .964.964 0 0 1 0-1.406l3.219-3.22c.281-.28.594-.343.75-.343.125 0 .438.063.688.313l3.218 3.218c.438.406.438 1.063.031 1.438Z"
  })));
};

export default SvgCircleUpSolid;